import type buyNowEvents from './events/buyNowEvents';

export enum GtmEventInteractiveAction {}

export enum EEventName {
  EVENT_INTERACTIVE = 'event-interactive',
  PAGE_VIRTUAL = 'page-virtual',
  ERROR = 'error_event',
  BEGIN_CHECKOUT = 'begin_checkout',
  ADD_PAYMENT_INFO = 'add_payment_info',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  PURCHASE = 'purchase'
}

type TEventName = EEventName;

type Event = {
  event?: TEventName;
};

export enum BuyNowEventInteractiveCategories {
  FastCheckout = 'fast checkout',
  HeaderInteractions = 'interacciones header',
  CheckoutInfo = 'Checkout Info',
  CheckoutShipping = 'Checkout Shipping',
  Error = 'error'
}

export enum BuyNowEventInteractiveActions {
  Clic = 'clic',
  Respuesta = 'Respuesta'
}

export enum BuyNowEventInteractiveTags {
  PayButton = 'boton pagar',
  Logo = 'logo',
  OtherPaymentMethods = 'boton otros medios de pago',
  PaymentMethodsGoToCart = 'medios pago - ir al carro',
  Despacho = 'despacho',
  Retiro = 'retiro',
  OpcionesRetiro = 'opciones retiro - continua desde el carro',
  SinStockExplorarProductos = 'explorar productos',
  SinStockGuardarProducto = 'guardar',
  SinStockCerrarModal = 'x',
  SinStockPantalla = 'Producto no disponible No posee ningún tipo de entrega disponible',
  AddCouponButton = 'boton agregar cupon',
  RemoveCouponButton = 'eliminar cupon',
  RemoveCouponModalBackButton = 'volver modal eliminar cupon',
  RemoveCouponModalConfirmButton = 'confirmar modal eliminar cupon',
  ExitModalSalir = 'salir modal exit intent',
  ExitModalCompletarCompra = 'Completar compra modal exit intent',
  ElegirOtraTarjeta = 'elegir otra tarjeta',
  ElegirOtraFecha = 'elegir otra fecha',
  RetiraOtraPersona = 'retira otra persona',
  ExitIdleModalSalir = 'salir modal time out',
  ExitIdleModalCompletarCompra = 'continuar con el pago modal time out',
  DireccionesIrAlCarro = 'direcciones - ir al carro',
  BotonEditarDireccion = 'boton editar direccion'
}

export enum BuyNowEventInteractivePageNames {
  FastCheckout = 'fast checkout'
}

export enum BuyNowEventCartType {
  FastCheckoutCart = 'fast-checkout'
}

interface EcommerceBase {
  flujo_checkout: string;
  items: GtmArrayItems;
}

export interface EcommerceCheckout extends EcommerceBase {
  shipping_region?: string;
  shipping_comune?: string;
}

export interface EcommercePurchase extends EcommerceBase {
  payment_method: string;
  transaction_id: string;
  value: number;
  shipping: number;
  tax: number;
  coupon: string;
  affiliation?: string;
  currency: string;
}

export type EcommerceDataFC = EcommerceCheckout | EcommercePurchase;

export interface GtmEvent extends Event {
  'event-interactive-category'?: BuyNowEventInteractiveCategories;
  'event-interactive-accion'?: BuyNowEventInteractiveActions | string;
  'event-interactive-tag'?: BuyNowEventInteractiveTags | string;
  'event-interactive-grupo_despacho'?: string;
  'event-interactive-vendedor'?: string;
  'event-interactive-sku'?: string;
  'event-interactive-value'?: number;
  'event-interactive-leadtime_despacho'?: string;
  'event-interactive-leadtime_retiro'?: string;
  'event-interactive-leadtime_puntoscopec'?: string;
  dimension46?: number;
  dimension47?: string;
  ecommerce?: EcommerceDataFC;
  pagename?: string;
}
export interface GtmArrayItem {
  item_id: string;
  item_name: string;
  item_list_name: string;
  item_variant: string;
  item_category: string;
  item_brand: string;
  price: number;
  list_price: number;
  cenco_price: number;
  cod_depto: string;
  dpto: string;
  cod_base: string;
  base: string;
  cod_subdpto: string;
  subdpto: string;
  tipo_envio: string;
  garantia: boolean;
  nombre_garantia: string;
  seller: string;
  sponsoredproducts: boolean;
  quantity: number;
}

export type GtmArrayItems = GtmArrayItem[];

export type BuyNowEvent = GtmEvent;

export type BuyNowEventKeys = keyof typeof buyNowEvents;

export type SendGtmEvent = {
  event: BuyNowEventKeys;
  extraFields?: Partial<BuyNowEvent>;
};
